class ProductTabs extends HTMLElement {
    constructor() {
        super();
        
        this.tab = this.querySelectorAll('.tab-title');
        this.tabContents = this.querySelector('.tabs-contents');
        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');
        this.readMore = this.querySelectorAll('[data-show-more-toogle]');
        this.tabClose = this.querySelectorAll('.pdViewTab-close');
        this.isVerticalPopup = this.dataset.vertical === 'sidebar'
        this.isVerticalSidebarMobile = this.dataset.verticalMobile === 'sidebar-mobile'
        const defaultProductPage = this.closest('.product-default')?.closest('.template-product')
        this.mobilePopupBreakpoint = defaultProductPage ? 767 : 550
        this.isProductDrawer = Boolean(defaultProductPage && this.classList.contains('layout-vertical'))

        if (this.isProductDrawer) {
            this.initializeProductDrawer()
        }

        for (let i = 0; i < this.tab.length; i++) {
            this.tab[i].addEventListener(
                'click',
                this.tabActive.bind(this)
            );
        }
            
        for (let i = 0; i < this.link.length; i++) {
            this.link[i].addEventListener(
                'click',
                this.tabToggle.bind(this)
            );
        }

        document.addEventListener('click', e => {
            if (e.target.matches('[data-show-more-toogle]') || e.target.closest('[data-show-more-toogle]')) {
                this.readMoreReadLess(e)
            }
            else if (e.target.matches('.pdViewTab-close') || e.target.closest('.pdViewTab-close')) {
                this.productTabClose(e)

                if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
                    this.handleVerticalPopupClose(e)
                }
            }
        });

        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
            document.querySelector('.background-overlay')?.addEventListener('click', this.onBackgroundClick.bind(this));
        }

        if (this.isProductDrawer) {
            this.drawerClose.addEventListener('click', this.closeProductDrawer.bind(this))
            this.drawerBackdrop.addEventListener('click', this.closeProductDrawer.bind(this))
            document.addEventListener('keydown', this.onProductDrawerKeydown.bind(this))
        }

        setTimeout(() => {
            if (window.innerWidth > this.mobilePopupBreakpoint) {
                const descriptionContent = document.getElementById('tab-description-mobile');
                const showMoreContainer = descriptionContent?.querySelector('.tab-showMore');

                if (!descriptionContent || !showMoreContainer) return;

                const tabHeight = descriptionContent.offsetHeight;
                const maxHeight = Number.parseInt(showMoreContainer.dataset.desMax, 10);
                if (Number.isFinite(maxHeight) && tabHeight < maxHeight) {
                    showMoreContainer.remove();
                }
            }
        })
    }
    
    tabActive(event){
        event.preventDefault();
        event.stopPropagation();

        var $this = event.target,
            id = $this.getAttribute('href').replace('#', ''),
            button_tab = document.querySelector('.an-horizontal-shaking');

        if(!$this.classList.contains('is-open')) {
            this.tab.forEach((element, index) => {
                element.classList.remove('is-open');
            });

            $this.classList.add('is-open');
            this.tabContents.classList.add('is-show');
            button_tab?.classList.add('open-tab-content');

            this.tabContent.forEach((element, index) => {
                if(element.getAttribute('id') == id){
                    element.classList.add('is-active');
                } else {
                    element.classList.remove('is-active');
                }
            });
        }   

        if($this.classList.contains('open-tab-content')) {
            button_tab?.classList.remove('open-tab-content');
        }

        this.checkTabShowMore(id);
    }

    tabToggle(event){
        event.preventDefault();
        event.stopPropagation();
        
        var $this = event.currentTarget,
            $thisContent = $this.parentNode.nextElementSibling;

        if (this.isProductDrawer) {
            this.openProductDrawer(Number.parseInt($this.dataset.drawerIndex, 10), $this)
            return
        }

        if ($this.classList.contains('popup-mobile') && window.innerWidth <= this.mobilePopupBreakpoint) {
            if ($($thisContent).hasClass('is-show')) {
                $($thisContent).removeClass('is-show');
            }
            else {
                $($thisContent).addClass('is-show');
            }
        }
        else {
            if(window.innerWidth <= this.mobilePopupBreakpoint && $this.classList.contains('show-mobile')) {
                $this.classList.remove('is-open');
                $this.classList.remove('show-mobile');
                $($thisContent).slideUp('slow');
            }
            else if($this.classList.contains('is-open')){
                $this.classList.remove('is-open');
                if ((this.isVerticalPopup && window.innerWidth > this.mobilePopupBreakpoint) || ($this.matches('.sidebar-mobile') && window.innerWidth <= this.mobilePopupBreakpoint)) {
                    $thisContent.classList.remove('is-show');
                    document.body.classList.remove('tab-popup-show');
                }
                else {
                    $($thisContent).slideUp('slow');
                }
            } else {
                $this.classList.add('is-open');
                if ((this.isVerticalPopup && window.innerWidth > this.mobilePopupBreakpoint) || ($this.classList.contains('sidebar-mobile') && window.innerWidth <= this.mobilePopupBreakpoint)) {
                    document.body.classList.add('tab-popup-sidebar-show');
                    $thisContent.classList.add('is-show');
                    document.body.classList.add('tab-popup-show');
                } else {
                    $($thisContent).slideDown('slow');
                }
            }
        }
    }

    readMoreReadLess(event){
        event.preventDefault();
        event.stopPropagation();

        var $this = event.target || event.target.closest('[data-show-more-toogle]'),
            id = $this.getAttribute('href').replace('#', ''),
            textShowMore = $this.getAttribute('data-show-more-text'),
            textShowLess = $this.getAttribute('data-show-less-text'),
            desMax = $this.closest('.tab-showMore').dataset.desMax;

        if($this.classList.contains('is-less')) {
            $this.closest('.tab-showMore').classList.remove('is-less');
            $this.classList.remove('is-less');
            $this.closest('.tab-showMore').classList.add('is-show');
            $this.classList.add('is-show');
            $this.innerText = textShowMore;
            document.getElementById(`${id}`).style.maxHeight = `${desMax}px`;
            this.tabContents.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
        } else {
            $this.closest('.tab-showMore').classList.remove('is-show');
            $this.classList.remove('is-show');
            $this.closest('.tab-showMore').classList.add('is-less');
            $this.classList.add('is-less');
            $this.innerText = textShowLess;
            document.getElementById(`${id}`).style.maxHeight = 'unset';
        }
    }

    productTabClose(event) {
        event.preventDefault();
        event.stopPropagation();

        this.tabContents.classList.remove('is-show');

        this.tab.forEach((element, index) => {
            element.classList.remove('is-open');
            document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
        });

        this.tabContent.forEach((element, index) => {
            element.classList.remove('is-active');
            document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
        });

        if (window.innerWidth <= this.mobilePopupBreakpoint) {
            const $toggleContent = event.target.closest('.toggle-content');

            $toggleContent?.classList.remove('is-show');
        }
    }

    checkTabShowMore(id) {
        if (window.innerWidth > this.mobilePopupBreakpoint) {
            const tabContent = document.getElementById(`${id}`);
            const showMoreContainer = tabContent?.querySelector('.tab-showMore');

            if (!tabContent || !showMoreContainer) return;

            const tabHeight = tabContent.offsetHeight;
            const maxHeight = Number.parseInt(showMoreContainer.dataset.desMax, 10);
            if (Number.isFinite(maxHeight) && tabHeight < maxHeight) {
                showMoreContainer.remove();
            }
        }
    }

    onBackgroundClick(event) {
        if (event.target.closest('.toggle-content.is-show') != null) return 
        document.querySelector('.toggleLink.is-open')?.classList.remove('is-open');
        document.querySelector('.toggle-content.is-show')?.classList.remove('is-show');
        document.body.classList.remove('tab-popup-show');
    }

    handleVerticalPopupClose(event) {
        const closeButton = event.target
        closeButton.closest('.toggle-content')?.classList.remove('is-show')
        closeButton.closest('.tab-content')?.querySelector('.toggleLink')?.classList.remove('is-open')
        document.body.classList.remove('tab-popup-show')
    }

    initializeProductDrawer() {
        this.classList.add('product-tab-drawer-enabled')
        this.drawerItems = []

        const drawer = document.createElement('div')
        drawer.className = 'product-tab-drawer'
        drawer.setAttribute('aria-hidden', 'true')

        const backdrop = document.createElement('button')
        backdrop.className = 'product-tab-drawer__backdrop'
        backdrop.type = 'button'
        backdrop.tabIndex = -1
        backdrop.setAttribute('aria-label', 'Close product information')

        const panel = document.createElement('div')
        panel.className = 'product-tab-drawer__panel'
        panel.setAttribute('role', 'dialog')
        panel.setAttribute('aria-modal', 'true')
        panel.setAttribute('aria-label', 'Product information')

        const header = document.createElement('div')
        header.className = 'product-tab-drawer__header'

        const close = document.createElement('button')
        close.className = 'product-tab-drawer__close'
        close.type = 'button'
        close.setAttribute('aria-label', 'Close product information')
        header.appendChild(close)

        const contentContainer = document.createElement('div')
        contentContainer.className = 'product-tab-drawer__content-container'

        this.tabContent.forEach((tabContent, index) => {
            const sourceTrigger = tabContent.querySelector('.toggleLink')
            const sourceContent = tabContent.querySelector('.toggle-content')

            if (!sourceTrigger || !sourceContent) return

            const title = sourceTrigger.querySelector('.text')?.textContent.trim() || ''
            const item = document.createElement('section')
            const titleElement = document.createElement('h2')
            const content = document.createElement('div')
            const sourceContentBody = sourceContent.querySelector('.tab-popup-content') || sourceContent

            item.className = 'product-tab-drawer__item'
            titleElement.className = 'product-tab-drawer__title'
            titleElement.textContent = title

            sourceTrigger.dataset.drawerIndex = index
            sourceTrigger.setAttribute('aria-haspopup', 'dialog')
            sourceTrigger.classList.remove('is-open')

            content.className = 'product-tab-drawer__content'
            Array.from(sourceContentBody.childNodes).forEach((node) => {
                content.appendChild(node.cloneNode(true))
            })
            content.querySelector('.tab-showMore')?.remove()
            content.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'))

            // if (title !== 'Physical Stores' && title !== 'Leather Care Tips') {
            //     item.append(titleElement)
            // }
            item.append(content)
            contentContainer.appendChild(item)
            this.drawerItems[index] = { item, content }
        })

        panel.append(header, contentContainer)
        drawer.append(backdrop, panel)
        document.body.appendChild(drawer)

        this.drawer = drawer
        this.drawerPanel = panel
        this.drawerBackdrop = backdrop
        this.drawerClose = close
    }

    openProductDrawer(index, sourceTrigger) {
        if (!this.drawerItems[index]) return

        window.clearTimeout(this.drawerCloseTimer)
        this.lastDrawerTrigger = sourceTrigger
        this.closeProductDrawerItems(false)
        this.drawer.classList.add('is-visible')
        this.drawer.setAttribute('aria-hidden', 'false')
        document.body.classList.add('product-tab-drawer-open')
        this.drawerPanel.scrollTop = 0

        this.drawerAnimation?.cancel()
        this.drawerBackdropAnimation?.cancel()
        const closedTransform = this.getProductDrawerClosedTransform()
        this.drawerPanel.style.transform = closedTransform
        this.drawerBackdrop.style.opacity = '0'
        this.drawerPanel.getBoundingClientRect()

        window.requestAnimationFrame(() => {
            this.drawer.classList.add('is-open')
            this.drawerAnimation = this.drawerPanel.animate(
                [
                    { transform: closedTransform },
                    { transform: 'translate3d(0, 0, 0)' }
                ],
                {
                    duration: 480,
                    easing: 'cubic-bezier(.22, .61, .36, 1)',
                    fill: 'forwards'
                }
            )
            this.drawerBackdropAnimation = this.drawerBackdrop.animate(
                [{ opacity: 0 }, { opacity: 1 }],
                { duration: 360, easing: 'ease-out', fill: 'forwards' }
            )
            this.drawerAnimation.finished.then(() => {
                if (!this.drawer.classList.contains('is-open')) return
                this.drawerPanel.style.transform = 'translate3d(0, 0, 0)'
                this.drawerAnimation.cancel()
            }).catch(() => {})
            this.drawerBackdropAnimation.finished.then(() => {
                if (!this.drawer.classList.contains('is-open')) return
                this.drawerBackdrop.style.opacity = '1'
                this.drawerBackdropAnimation.cancel()
            }).catch(() => {})
            this.openProductDrawerItem(index, true)
        })
        window.setTimeout(() => this.drawerClose.focus(), 200)
    }

    openProductDrawerItem(index, animate = true) {
        const drawerItem = this.drawerItems[index]
        if (!drawerItem) return

        drawerItem.item.classList.add('is-open')
        drawerItem.content.style.height = '0px'
        drawerItem.content.style.opacity = '0'

        const finishOpen = (event) => {
            if (event.target !== drawerItem.content || event.propertyName !== 'height') return
            drawerItem.content.style.height = 'auto'
            drawerItem.content.removeEventListener('transitionend', finishOpen)
        }

        if (!animate) {
            drawerItem.content.style.height = 'auto'
            drawerItem.content.style.opacity = '1'
            return
        }

        drawerItem.content.getBoundingClientRect()
        window.requestAnimationFrame(() => {
            drawerItem.content.style.height = `${drawerItem.content.scrollHeight}px`
            drawerItem.content.style.opacity = '1'
        })
        drawerItem.content.addEventListener('transitionend', finishOpen)
    }

    closeProductDrawerItems(animate = true, exceptIndex = -1) {
        this.drawerItems.forEach((drawerItem, index) => {
            if (!drawerItem) return

            if (index === exceptIndex) return

            const wasOpen = drawerItem.item.classList.contains('is-open')
            if (animate && wasOpen) {
                drawerItem.content.style.height = `${drawerItem.content.scrollHeight}px`
                drawerItem.content.getBoundingClientRect()
            }

            drawerItem.item.classList.remove('is-open')

            if (animate && wasOpen) {
                window.requestAnimationFrame(() => {
                    drawerItem.content.style.height = '0px'
                    drawerItem.content.style.opacity = '0'
                })
            } else {
                drawerItem.content.style.height = '0px'
                drawerItem.content.style.opacity = '0'
            }
        })
    }

    closeProductDrawer(event) {
        event?.preventDefault()
        if (!this.drawer.classList.contains('is-visible')) return

        document.body.classList.remove('product-tab-drawer-open')
        this.closeProductDrawerItems(false)

        window.clearTimeout(this.drawerCloseTimer)
        this.drawerAnimation?.cancel()
        this.drawerBackdropAnimation?.cancel()
        const closedTransform = this.getProductDrawerClosedTransform()

        this.drawerAnimation = this.drawerPanel.animate(
            [
                { transform: 'translate3d(0, 0, 0)' },
                { transform: closedTransform }
            ],
            {
                duration: 440,
                easing: 'cubic-bezier(.55, .06, .68, .19)',
                fill: 'forwards'
            }
        )
        this.drawerBackdropAnimation = this.drawerBackdrop.animate(
            [{ opacity: 1 }, { opacity: 0 }],
            { duration: 320, easing: 'ease-in', fill: 'forwards' }
        )
        this.drawer.classList.remove('is-open')

        const finishClose = () => {
            if (!this.drawer.classList.contains('is-visible')) return
            window.clearTimeout(this.drawerCloseTimer)
            this.drawer.classList.remove('is-visible')
            this.drawer.setAttribute('aria-hidden', 'true')
            this.drawerPanel.style.removeProperty('transform')
            this.drawerBackdrop.style.removeProperty('opacity')
            this.lastDrawerTrigger?.focus()
        }

        this.drawerAnimation.finished.then(finishClose).catch(() => {})
        this.drawerCloseTimer = window.setTimeout(finishClose, 500)
    }

    getProductDrawerClosedTransform() {
        return window.innerWidth <= this.mobilePopupBreakpoint
            ? 'translate3d(0, 100%, 0)'
            : 'translate3d(100%, 0, 0)'
    }

    onProductDrawerKeydown(event) {
        if (event.key === 'Escape' && this.drawer.classList.contains('is-open')) {
            this.closeProductDrawer(event)
        }
    }
}

if (!customElements.get('product-tab')) {
    customElements.define('product-tab', ProductTabs);
}
